import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=63f0b03a&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=63f0b03a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f0b03a",
  null
  
)

export default component.exports